<div class="w-100 h-100 register-container">
  <div class="floating-logo mb-0">
    <img src="assets/images/logo-4.png" alt="" style="width: 100%" />
  </div>
  <div class="h-100 d-flex flex-column" style="gap: 0px">
    <!-- <div
      class="d-flex justify-content-between align-items-center header p-2 p-sm-3 w-100 position-relative">
      <div class="do-logo mb-0">
        <img src="assets/images/logo-4.png" alt="" style="width: 100%" />
      </div>

      <div class="d-flex flex-row align-items-center gap-1 gap-sm-2">
        <span class="material-icons-outlined" title="Selected Currency">
          currency_exchange
        </span>
        <dx-select-box
          [items]="countryCurrency"
          displayExpr="displayExpr"
          valueExpr="currency"
          [(value)]="selectedCountryCurrency"
          (onValueChanged)="selectedCountryCurrencyChanged()"
          class="selectedCountryCurrency"
          id="selectedCountryCurrency"></dx-select-box>
      </div>
    </div> -->
    <div class="flex-grow-1 custom-container overflow-hidden">
      <!-- <app-custom-stepper
                [stepCount]="stepCount"
                [selectedStep]="selectedStep">
            </app-custom-stepper> -->

      <!-- Registration Form -->
      <div *ngIf="subscriptionStep" [formGroup]="registrationForm"
        class="registration-form-container overflow-hidden w-100 d-flex flex-column justify-content-center"
        style="position: relative" [ngClass]="{ organizationDetails: selectedStep === 4 }">
        <!-- <ng-template [ngIf]="selectedStep === subscriptionStep.plans">
                    <app-plan-selector
                        [subscriptionState]="subscriptionState"
                        [selectedCountryCurrency]="selectedCountryCurrency"
                        (saveTriggered)="savePlanDetails()"
                        (onBillingCycleChanged)="onBillingCycleChanged($event)"
                        [subscriptionBillingCycle]="selectedBillingCycle"
                        (subscriptionStateChanged)="subscriptionStateChanged($event)"
                        [backButtonEnabled]="false"
                        (sketchAppChanged)="selectedPlans = $event.selectedPlans; totalCost = $event.totalCost"
                        class="h-100 d-flex justify-content-center align-items-center">
                    </app-plan-selector>
                </ng-template> -->

        <ng-template [ngIf]="selectedStep === subscriptionStep.email">
          <div formGroupName="userDetails" [style]="commonStyle" class="email-address-container transition">
            <p class="sign-up"><img src="assets/images/logo-3.png" alt="" style="width: 38px" class="me-2" />Sign Up</p>
            <!-- <span clas="text-muted text-center mb-2 mt-1">Create Your Account</span> -->
            <div class="overflow-auto custom-scrollbar">
              <p class="fw-bold mt-3 text-muted">Email Address</p>
              <dx-text-box mode="email" id="emailTextBox" formControlName="userName" placeholder="Enter your email"
                [width]="'100%'" class="mx-auto custom-field border-0"
                (onValueChanged)="verifyEmailAddress(emailVerificationFlag, true)"></dx-text-box>
              <div *ngIf="emailVerificationFlag || true">
                <!-- <p class="fw-bold mt-3 text-muted">Password</p>
                <dx-text-box [(mode)]="passwordMode" formControlName="password" placeholder="Password" [width]="'100%'"
                  class="mx-auto custom-field border-0 mt-3">
                  <dxi-button name="today" location="after" [options]="passwordButton"></dxi-button>
                </dx-text-box>
                <dx-text-box [(mode)]="confirmPasswordMode" formControlName="confirmPassword"
                  placeholder="Confirm Password" [width]="'100%'" class="mx-auto custom-field border-0 mt-3">
                  <dxi-button name="today" location="after" [options]="confirmPasswordButton"></dxi-button>
                </dx-text-box> -->
                <p class="fw-bold mt-3 text-muted">Personal Details</p>
                <dx-text-box formControlName="firstName" [labelMode]="'floating'" placeholder="First Name"
                  class="border-0">
                  <dxi-validation-rule type="required" message="First Name is required"></dxi-validation-rule>
                </dx-text-box>

                <dx-text-box formControlName="lastName" [labelMode]="'floating'" placeholder="Last Name"
                  class="mt-3 border-0">
                  <dxi-validation-rule type="required" message="Last Name is required"></dxi-validation-rule>
                </dx-text-box>
                <div class="d-flex flex-sm-row gap-2 mt-3 w-100 justify-content-between">
                  <dx-select-box formControlName="countryCode" [labelMode]="'floating'" [searchEnabled]="true"
                    [searchMode]="'contains'" [items]="countryCodeExtended" class="border-0" valueExpr="country_code"
                    value="45" [displayExpr]="countryCodeDisplayExpr">
                    <dxi-validation-rule type="required" message="Country Code is required"></dxi-validation-rule>
                  </dx-select-box>
                  <dx-text-box formControlName="phone" [labelMode]="'floating'" placeholder="Phone Number"
                    class="flex-grow-1 border-0">
                    <dxi-validation-rule type="required" message="Phone Number is required"></dxi-validation-rule>
                  </dx-text-box>
                </div>
                <div *ngIf="showPasswordErrors()" class="password-error d-flex flex-column">
                  <small *ngIf="
                      registrationForm.hasError('mismatch') &&
                      this.registrationForm
                        .get('userDetails')
                        .get('confirmPassword').touched
                        ? true
                        : false
                    ">
                    Password and Confirm Password do not match
                  </small>
                  <small *ngIf="
                      registrationForm
                        .get('userDetails')
                        ?.get('password')
                        ?.hasError('minlength')
                    ">
                    Password must be at least 8 characters
                  </small>
                  <small *ngIf="
                      registrationForm
                        .get('userDetails')
                        ?.get('password')
                        ?.hasError('pattern')
                    ">
                    Password must include uppercase, lowercase, digit, and
                    special character
                  </small>
                </div>
              </div>
              <div *ngIf="emailErrorFlag">
                <p class="text-danger text-center mt-3 fw-medium">
                  {{ emailErrorString }}
                  <a *ngIf="userExistsFlag" href="" (click)="goToLoginPage()">
                    login
                  </a>
                </p>
              </div>
              <div class="d-flex justify-content-between align-items-center mt-3">
                <dx-button *ngIf="stepCount == 4" text="Back" icon="arrowleft" type="normal"
                  (onClick)="goBack()"></dx-button>
                <dx-button class="ml-auto" text="Next" icon="arrowright" type="default"
                  [disabled]="isVerifyEmailButtonDisabled()" [elementAttr]="{ class: 'next-button' }" (onClick)="
                    verifyEmailAddress(emailVerificationFlag)
                  "></dx-button>
              </div>
            </div>
          </div>
        </ng-template>

        <ng-template [ngIf]="selectedStep === subscriptionStep.organizationDetails">
          <div [style]="commonStyle" class="organization-details-container transition">
            <app-add-organisation class="overflow-auto custom-scrollbar" [width]="'100%'" boxShadow="none"
              [isMobile]="isMobile" [isNewUserRegistration]="true" (goBack)="goBack()"
              [organizationDetails]="organizationDetails" (saveOrganizationDetails)="
                saveOrganizationDetails($event)
              "></app-add-organisation>
          </div>
        </ng-template>

        <ng-container *ngIf="selectedStep === subscriptionStep?.orderSummary">
          <div [style]="commonStyle"
            class="d-flex flex-column overflow-auto order-summary-page custom-scrollbar p-sm-4">
            <div class="d-flex gap-2 flex-column-reverse flex-sm-row">
              <div class="border-en col-sm-7 p-4 py-2 rounded bg-whitesmoke no-border-en" style="line-height: 28px">
                <h3 class="text-center fw-bold" style="margin-bottom: 2rem">Checkout</h3>
                <div *ngFor="let plan of selectedPlans" class="mb-4">
                  <div class="d-flex flex-column">
                    <div class="d-flex mb-2 justify-content-between">
                      <div>
                        <h5 class="mb-1 fw-bold appName" title="Selected Product">
                          {{ appNames[plan.productType] }}
                        </h5>
                        <span class="text-muted mb-0">
                          {{ plan.name }}
                          {{
                          plan.unlimitedUsers
                          ? " - Unlimited Users"
                          : " - For " + plan.numberOfUsers + (plan.numberOfUsers === 1 ? " user" : " users")
                          }}
                        </span>
                      </div>
                      <h5 class="mb-0">
                        {{ plan.rate | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
                        selectedBillingCycle === "Monthly" ? "mo" : "yr"
                        }}
                      </h5>
                    </div>
                    <app-selected-app-description [selectedApp]="plan.productType" [showBulletPoints]="false"
                      [showDescription]="false">
                    </app-selected-app-description>
                  </div>

                  <div *ngIf="!plan.unlimitedUsers && userSlabs.length > 0">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="flex-column {{formSubmissionStatus===null ? 'd-flex': 'd-none'}} ">
                        <div>
                          <span>Add-on Users</span>
                          <button type="button" [id]="'info-button-' + plan.subscriptionTierId" class="d-inline info-button"
                            aria-label="Add-on user pricing">
                            <span class="material-icons-outlined" aria-hidden="true">info</span>
                          </button>
                        </div>
                        <div class="d-inline mt-2">
                          <div class="d-inline-flex gap-2 align-items-center">
                            <button type="button" (click)="updateAddOnUsers(plan, -1)" class="icon-button" aria-label="Remove add-on user">
                              <span class="material-icons-outlined" aria-hidden="true">
                                remove_circle_outline
                              </span>
                            </button>
                            <dx-number-box [(value)]="plan.addOnCount" (onValueChanged)="
                                updateAddOnUsers(plan, 0, $event)
                              " [min]="0" [max]="100" width="45px" class="text-center addon-input-box">
                            </dx-number-box>
                            <button type="button" class="icon-button" (click)="updateAddOnUsers(plan, 1)" aria-label="Add add-on user">
                              <span class="material-icons-outlined plus" aria-hidden="true">
                                add_circle_outline
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="ms-auto" *ngIf="plan.addOnCount > 0">
                        <h5 class="mb-0">
                          +{{ plan.addOnCost | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
                          selectedBillingCycle === "Monthly"
                          ? "mo"
                          : "yr"
                          }}
                        </h5>
                        <p class="text-muted mb-0">
                          ({{ plan.addOnCount }} * {{ plan.addOnRate | number:'1.0-0' }}
                          {{ selectedCountryCurrency }}/user)
                        </p>
                      </div>
                      <dx-popover [target]="'#info-button-' + plan.subscriptionTierId" showEvent="mouseover touchstart" hideEvent="mouseout touchend">
                        <div *dxTemplate="let data of 'content'">
                          <ng-container *ngFor="let slab of getAddOnUserPricing(plan)">
                            <p class="mb-0">{{ slab }}</p>
                            <br />
                          </ng-container>
                        </div>
                      </dx-popover>
                    </div>
                  </div>
                </div>

                <div class="pt-2 mt-2">
                  <div class="d-flex justify-content-between">
                    <h4 class="fw-bold">Net Total</h4>
                    <h4 class="fw-bold net-total-amount">
                      {{ totalCost | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
                      selectedBillingCycle === "Monthly" ? "mo" : "yr"
                      }}
                    </h4>
                  </div>
                </div>

                <div class="border-top mt-3 pt-3">
                  <app-payment-info [(selected)]="isPaymentSelected" [trialDays]="selectedPlans[0].numberOfTrialDays" [disabled]="formSubmissionStatus === 'awaiting'">
                  </app-payment-info>
                </div>
              </div>

              <div class="mb-3 d-flex flex-column bg-whitesmoke rounded mb-sm-0 col-sm-5 p-3 ps-sm-4">
                <div class="d-flex flex-column">
                  <h4 class="mb-3 fw-bold">User Details</h4>
                  <div style="margin-bottom: 2rem">
                    <p class="mb-2">
                      <strong>Name:</strong>
                      {{ registrationForm.value.userDetails.firstName }}
                      {{ registrationForm.value.userDetails.lastName }}
                    </p>
                    <p class="mb-2">
                      <strong>Email:</strong>
                      {{ registrationForm.value.userDetails.userName }}
                    </p>
                    <p class="mb-0">
                      <strong>Phone:</strong>
                      +{{ registrationForm.value.userDetails.countryCode }}
                      {{ registrationForm.value.userDetails.phone }}
                    </p>
                  </div>
                </div>

                <div class="d-flex flex-column mb-3">
                  <h4 class="mb-3 fw-bold">Organization Details</h4>
                  <div>
                    <p class="mb-2">
                      <strong>Name:</strong>
                      {{
                      registrationForm.value.organisationDetails
                      .organisationName
                      }}
                    </p>
                    <p class="mb-2">
                      <strong>Reg No:</strong>
                      {{
                      registrationForm.value.organisationDetails
                      .companyRegistrationNumber
                      }}
                    </p>
                    <p class="mb-2">
                      <strong>Address:</strong>
                      {{ registrationForm.value.organisationDetails.address }},
                      {{ registrationForm.value.organisationDetails.city }},
                      {{ registrationForm.value.organisationDetails.zip }}
                    </p>
                    <p class="mb-2">
                      <strong>Country:</strong>
                      {{ registrationForm.value.organisationDetails.country }}
                    </p>
                    <p class="mb-2">
                      <strong>Contact:</strong>
                      {{
                      registrationForm.value.organisationDetails.contactPerson
                      }}
                      ({{
                      registrationForm.value.organisationDetails.contactNumber
                      }})
                    </p>
                    <p class="mb-0">
                      <strong>Email:</strong>
                      {{ registrationForm.value.organisationDetails.email }}
                    </p>
                  </div>
                </div>

                <p class="text-muted mt-auto pt-3">
                  <dx-check-box class="me-2" [disabled]="formSubmissionStatus === 'awaiting'"
                    [(value)]="isLicenseAccepted">
                  </dx-check-box>
                  By checking this box, I accept the
                  <span style="text-decoration: underline; color: #0fa2d9; cursor: pointer;"
                    (click)="openLicenseAgreement($event)">
                    License Agreement
                  </span>
                </p>
              </div>
            </div>

            <div class="mt-4 text-center" *ngIf="formSubmissionStatus === null">
              <div class="d-flex justify-content-between align-items-center">
                <dx-button text="Back" icon="arrowleft" type="normal" (onClick)="goBack()"></dx-button>
                <button [disabled]="!isPaymentSelected || !isLicenseAccepted" class="complete-button px-5"
                  (click)="submitForm()">
                  Place Order
                </button>
              </div>
            </div>

            <div class="registration-status mt-3">
              <div class="d-flex h-100 justify-content-center align-items-center gap-3"
                *ngIf="formSubmissionStatus === 'awaiting'">
                <h4 class="fw-bold text-center m-0">Account creation in progress</h4>
                <mat-spinner class="mat-spinner"></mat-spinner>
                <!-- <h6 class="mb-0 text-center">Account creation in progress...</h6> -->
              </div>

              <!-- <div class="d-flex h-100 justify-content-center align-items-center gap-1"
                *ngIf="formSubmissionStatus === 'success'">
                <span class="material-icons" style="color: #1da24f; font-size: 40px; height: 40px">
                  check_circle
                </span>
                <h4 class="fw-bold text-center m-0">Registration Successful</h4>
                <h5 class="m-0 fw-bold ms-auto">Please check your email for a login link to access your account.</h5>
                <dx-button text="Login" icon="login" stylingMode="contained" [style.backgroundColor]="'#0fa2d9'"
                  [style.color]="'#ffffff'" class="ms-auto login-btn" type="default" (onClick)="goToLoginPage()"></dx-button>
              </div> -->

              <div class="d-flex h-100 justify-content-center align-items-center gap-3"
                *ngIf="formSubmissionStatus === 'failure'">
                <dx-button text="Back" icon="arrowleft" type="normal" (onClick)="goBack()"></dx-button>
                <span class="material-icons status-icon status-icon-error" aria-hidden="true">
                  cancel
                </span>
                <h4 class="fw-bold text-center m-0">
                  Registration Failed
                </h4>
                <h6 class="text-center m-0">
                  {{formSubmissionFailedMessage}}
                </h6>
                <button class="complete-button ms-auto" [disabled]="!isPaymentSelected || !isLicenseAccepted" (click)="submitForm()">
                  Try Again
                </button>
                <!-- <dx-button text="Close" stylingMode="contained" type="danger" class="ms-auto"
                  (onClick)="goToLoginPage()"></dx-button> -->
              </div>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="selectedStep === subscriptionStep?.success">
          <div class="success-container">
            <div class="success-card">
              <span class="material-icons status-icon status-icon-success" aria-hidden="true">
                check_circle
              </span>
              <h4 class="fw-bold text-center title">Registration Successful</h4>
              <p class="text">
                Thanks for signing up<span> for <strong>{{ appNames[selectedPlans[0].productType] }}</strong></span>!
                We’ve sent a verification email to
                <strong *ngIf="registrationForm.value.userDetails?.userName; else noEmail">{{
                  registrationForm.value.userDetails?.userName }}</strong>.
                Please verify your email and set your password to start using the app. You may now close this page.
              </p>
              <ng-template #noEmail>
                <em>(your email)</em>
              </ng-template>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="order-summary-container my-auto d-flex flex-column {{
          isSummaryHidden ? 'hide' : ''
        }}" (click)="changeSummaryVisibility()"
        *ngIf="selectedStep !== subscriptionStep?.orderSummary && selectedStep !== subscriptionStep?.success && selectedPlans.length"
        style="width: 34%; min-width: 400px;">
        <span class="d-flex flex-row justify-content-between align-items-center">
          <h4 class="fw-semibold m-0">Order Summary</h4>
          <!-- <span class="material-icons-outlined">shopping_cart</span> -->
          <div class="d-flex flex-row align-items-center gap-1 gap-sm-2">
            <span class="material-icons-outlined text-success" title="Selected Currency">
              currency_exchange
            </span>
            <dx-select-box (click)="$event.stopPropagation()" style="width: 74px;" [items]="countryCurrency"
              displayExpr="displayExpr" valueExpr="currency" [(value)]="selectedCountryCurrency"
              (onValueChanged)="selectedCountryCurrencyChanged()" class="selectedCountryCurrency"
              id="selectedCountryCurrency"></dx-select-box>
          </div>
        </span>
        <hr />
        <div *ngFor="let plan of selectedPlans"
          class="d-flex flex-column align-content-start mb-2 overflow-auto custom-hidden-scrollbar">
          <div class="d-flex justify-content-between">
            <div>
              <p class="fs-5 appName mb-0">{{ appNames[plan.productType] }}</p>
              <p class="planName">
                {{
                plan.name +
                (plan.unlimitedUsers
                ? " - Unlimited Users"
                : " - Upto " + plan.numberOfUsers + (plan.numberOfUsers === 1 ? " user" : " users"))
                }}
              </p>
            </div>
            <div class="d-flex flex-column">
              <p class="price m-0">
                {{ plan.rate | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
                selectedBillingCycle === "Monthly" ? "mo" : "yr"
                }}
              </p>
              <span *ngIf="plan.numberOfTrialDays > 0" class="trial-days mt-1">
                {{plan.numberOfTrialDays}} Days Free!
              </span>
            </div>
          </div>
          <app-selected-app-description class="overflow-auto custom-scrollbar" [selectedApp]="plan.productType"
            [showBulletPoints]="true" [showDescription]="false">
          </app-selected-app-description>
        </div>

        <div class="mt-auto bg-whitesmoke rounded p-3 d-flex justify-content-between align-items-center"
          *ngIf="totalCost !== 0">
          <p class="fs-5 fw-bold mb-0">Net Total</p>
          <!-- <hr class="mt-1 mb-1" /> -->
          <div class="total align-self-end">
            <span class="price fw-bold net-total-price">
              {{ totalCost | number:'1.0-0' }} {{ selectedCountryCurrency }}/{{
              selectedBillingCycle === "Monthly" ? "mo" : "yr"
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- 
<div [style]="commonStyle" class="overflow-auto transition plan-container">
    <div class="mx-auto do-logo">
        <img src="assets/images/logo-4.png" alt="" style="width: 100%;">
    </div>
    <h4 class="text-center">Select Plans</h4>
    <div>
        <div class="tab-switcher d-flex flex-row mb-4" *ngIf="subscriptionState.viewMode === viewMode.multi">
            <div class="flex-grow-1 tab" 
            *ngFor="let app of apps; let i = index"  
            [ngClass]="{'selected-tab': subscriptionState.selectedApp === app || (isSketchSelected() && isSketchSelected(app))}" 
            (click)="switchTab(app)">
                <div class="w-100 text-center">
                    {{ isSketchSelected(app) ? 'Sketch' :  appNames[app]}}
                    <span style="color: #9bff37;" *ngIf="subscriptionState.selectedPlans[app] !== null">•</span>
                </div>
            </div>
        </div>

        <div class="tab-switcher d-flex flex-row mb-4" *ngIf="subscriptionState.viewMode === viewMode.single">
            <div class="flex-grow-1 tab selected-tab">
                <div class="w-100 text-center">
                    {{appNames[subscriptionState.selectedApp]}}
                    <span style="color: #9bff37;" *ngIf="subscriptionState.selectedPlans[subscriptionState.selectedApp] !== null">•</span>
                </div>
            </div>
        </div>

        <div class="filters-container d-flex flex-row gap-2 ms-2 mb-3 align-items-center" *ngIf="isSketchSelected()">
            Sketch Variant:
            <dx-select-box
                class="ms-2"
                [dataSource]="ctsFilter"
                [value]="ctsFilterValue"
                id="ctsFilter"
                [classList]="'ctsFilter'"
                (onValueChanged)="getSketchAppVariants($event)">
            </dx-select-box>

            <div class="cad-software-selector d-flex flex-row align-items-center">
                CAD Software:
                <div class="cad-software-list d-flex flex-row justify-content-evenly gap-2 ms-2">
                    <div class="cad-software d-flex flex-row align-items-center" 
                        (click)="changeSketchApp($event, software)"
                        [ngClass]="{'selected': software.cadSoftwareId === selectedCadSoftware}" 
                        *ngFor="let software of cadSoftwares;">
                        <div class="image me-2 mb-1" style="width: 16px;">
                            <img [src]="software.thumbnail" [alt]="software.cadSoftwareName" style="width: 100%;">
                        </div>
                        <div class="caption fw-medium">
                            {{software.cadSoftwareName}}
                        </div>
                    </div>
                </div>
            </div>

            <dx-select-box
                [dataSource]="sketchVariants"
                displayExpr="value"
                valueExpr="key"
                id="cadAppFilter"
                [classList]="'cadAppFilter'"
                [value]="sketchVariantValue"
                (onValueChanged)="changeSketchApp($event)">
            </dx-select-box>
        </div>
    </div>

    <div class="d-flex gap-4 align-items-center justify-content-around" [ngClass]="isMobile ? 'flex-column' : 'flex-row flex-wrap'">
        <app-plan-card 
            class="w-100 plan-card"
            *ngFor="let plan of filteredPlans; let i=index"
            [planName]="plan.name"
            [userCount]="plan.numberOfUsers"
            [templateCount]="plan.numberOfTemplates"
            [subscriptionCost]="plan.rate"
            [currency]="plan.currency"
            [isUnlimitedUsers]="plan.unlimitedUsers"
            [isUnlimitedTemplates]="plan.unlimitedTemplates"
            [selected]="subscriptionState.selectedPlans[subscriptionState.selectedApp] === plan.subscriptionTierId"
            [app]="subscriptionState.selectedApp"
            [planId]="plan.subscriptionTierId"
            (planSelected)="switchPlan($event)"
            (planDeselected)="switchPlan($event)"
            >
        </app-plan-card>
    </div>

    <div class="d-flex flex-row justify-content-end align-items-center mt-3">
        <dx-button
            text="Back"
            icon="arrowleft"
            type="normal"
            (onClick)="goBack()">
        </dx-button>
        <dx-button
            text="Next"
            icon="arrowright"
            [rtlEnabled]="true"
            [elementAttr]="{class: 'next-button'}"
            type="default"
            (onClick)="savePlanDetails()">
        </dx-button>
    </div>
</div> -->